/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M4.25 3.75C4.25 2.2312 5.4812 1 7 1h5.6972c.3455 0 .6833.1023.9707.294L16.2271 3H19c1.5188 0 2.75 1.2312 2.75 2.75v4.1055C23.2257 11.4058 24 12.75 24 12.75s-.7743 1.3442-2.25 2.8945V20.25c0 1.5188-1.2312 2.75-2.75 2.75H7c-1.5188 0-2.75-1.2312-2.75-2.75v-3.1121C1.6378 15.0764 0 12.75 0 12.75s1.6378-2.3264 4.25-4.3879V3.75Zm16 2v2.6983C18.2414 6.774 15.4621 5.25 12 5.25c-2.3042 0-4.4392.8818-6.25 2.0407V3.75c0-.6904.5596-1.25 1.25-1.25h5.6972a.25.25 0 0 1 .1387.042l2.7481 1.832.1889.126H19c.6904 0 1.25.5596 1.25 1.25ZM12 20.25c3.4621 0 6.2414-1.5241 8.25-3.1983V20.25c0 .6904-.5596 1.25-1.25 1.25H7c-.6904 0-1.25-.5596-1.25-1.25v-2.0407C7.5608 19.3682 9.6958 20.25 12 20.25Zm-10.0961-7.5c.0528.0634.1086.1296.1671.1982.5647.6618 1.3823 1.5423 2.3923 2.419C6.5265 17.1582 9.1808 18.75 12 18.75c3.3264 0 5.9802-1.6221 7.8649-3.3544.9362-.8604 1.6549-1.7239 2.1382-2.3712.0723-.0968.1391-.1885.2004-.2744a16.0468 16.0468 0 0 0-.2004-.2744c-.4833-.6473-1.202-1.5108-2.1382-2.3712C17.9802 8.3721 15.3264 6.75 12 6.75c-2.8192 0-5.4735 1.5918-7.5367 3.3828-1.01.8767-1.8276 1.7572-2.3923 2.419a22.1178 22.1178 0 0 0-.1671.1982Zm12.5961 0c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2Zm1.5 0c0 1.933-1.567 3.5-3.5 3.5S9 14.683 9 12.75s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5Z"
    clipRule="evenodd"
  />,
  'ViewOnly'
);
